import { useAppSelector } from 'app/hooks';
import { DatePicker, SelectField, TextField } from 'components/Form';
import { addToDate } from 'helper/date';
import { UserTitlesType } from 'models/types';
import { useTranslation } from 'react-i18next';
import { complementaryFormDataState } from 'store/flight/flightSlice';
import { isLTRState } from 'store/options/optionsSlice';
import { NATIONALITY, TITLE_MENU } from 'utils/constants';
import { FlightBookPassengersFormProp } from './form.interface';
import * as S from './form.styles';

const FlightBookPassengersForm = ({ model, onChange }: FlightBookPassengersFormProp) => {
  const { t } = useTranslation();
  const isLTR = useAppSelector(isLTRState);
  // const complementaryFormData = useAppSelector(complementaryFormDataState);
  // onChange({...model, birthdate: getDate(model.birthdate, undefined, 'YYYY/MM/DD' )})

  const getMaxDate = () => {
    if (model.passengerTypeCode === 'ADT') return new Date(addToDate(new Date(), { year: -12 })).getTime();
    else if (model.passengerTypeCode === 'CHD') return new Date(addToDate(new Date(), { year: -2 })).getTime();
    return new Date().getTime();
  };
  const getMinDate = () => {
    if (model.passengerTypeCode === 'ADT') return null;
    else if (model.passengerTypeCode === 'CHD') return new Date(addToDate(new Date(), { year: -12 })).getTime();
    return new Date(addToDate(new Date(), { year: -2 })).getTime();
  };
  const { departureCountryCode, destinationCountryCode } = useAppSelector(complementaryFormDataState);

  const minBirthDate = getMinDate();
  const maxBirthDate = getMaxDate();

  return (
    <S.Wrapper>
      <S.Form>
        <S.FormGroup>
          <S.Field>
            <TextField
              label={t('pages.services.flight.pages.book.sections.passengers.sections.form.fields.firstName.label')}
              fullWidth
              defaultValue={model.fname}
              onChange={(e) => onChange({ ...model, fname: e.target.value })}
              disabled
            />
          </S.Field>
          <S.Field>
            <TextField
              label={t('pages.services.flight.pages.book.sections.passengers.sections.form.fields.surName.label')}
              fullWidth
              defaultValue={model.lname}
              onChange={(e) => onChange({ ...model, lname: e.target.value })}
              disabled
            />
          </S.Field>
          <S.Field>
            <SelectField
              autoCompelete
              menu={NATIONALITY}
              defaultValue={model.nationality}
              label={t('pages.services.flight.pages.book.sections.passengers.sections.form.fields.nationality.label')}
              onChange={(value) => onChange({ ...model, nationality: value })}
              disabled
            />
          </S.Field>
          <S.Field>
            <SelectField
              menu={TITLE_MENU}
              defaultValue={model.gender}
              label={t('pages.services.flight.pages.book.sections.passengers.sections.form.fields.title.label')}
              onChange={(value) => {
                onChange({ ...model, gender: value as UserTitlesType, title: value as UserTitlesType });
              }}
              disabled
            />
          </S.Field>
          <S.Field>
            <DatePicker
              label={t('pages.services.flight.pages.book.sections.passengers.sections.form.fields.birthdate.label')}
              defaultValue={model.birthdate}
              openTo="year"
              onChange={(date) =>
                onChange({
                  ...model,
                  birthdate: date,
                })
              }
              disabled
            />
          </S.Field>
          {model.nationality === 'IR' && destinationCountryCode === 'IR' && departureCountryCode === 'IR' ? (
            <S.Field>
              <TextField
                label={t('pages.services.flight.pages.book.sections.passengers.sections.form.fields.nationalId.label')}
                fullWidth
                defaultValue={model.nationalId}
                type="number"
                key={'nationalId'}
                onChange={(e) => onChange({ ...model, nationalId: e.target.value })}
                disabled
              />
            </S.Field>
          ) : (
            <>
              <S.Field>
                <TextField
                  label={t('pages.services.flight.pages.book.sections.passengers.sections.form.fields.docId.label')}
                  fullWidth
                  defaultValue={model.docId}
                  key={'docId'}
                  onChange={(e) => onChange({ ...model, docId: e.target.value })}
                />
              </S.Field>
              <S.Field>
                <SelectField
                  menu={NATIONALITY}
                  defaultValue={model.passportIssuingCountry}
                  label={t(
                    'pages.services.flight.pages.book.sections.passengers.sections.form.fields.passportCountry.label'
                  )}
                  onChange={(value) => {
                    onChange({ ...model, passportIssuingCountry: value });
                  }}
                />
              </S.Field>
              <S.Field>
                <DatePicker
                  label={t(
                    'pages.services.flight.pages.book.sections.passengers.sections.form.fields.docExpireDate.label'
                  )}
                  // {...defualtObj}
                  defaultValue={model.docExpireDate}
                  onChange={(date) =>
                    onChange({
                      ...model,
                      docExpireDate: date,
                    })
                  }
                />
              </S.Field>
            </>
          )}
          <S.Field>
            <TextField
              label={t('pages.services.flight.pages.book.sections.passengers.sections.form.fields.mobile.label')}
              fullWidth
              defaultValue={model.mobile}
              type="number"
              onChange={(e) => onChange({ ...model, mobile: e.target.value })}
              disabled
            />
          </S.Field>
          <S.Field>
            <TextField
              label={t('pages.services.flight.pages.book.sections.passengers.sections.form.fields.email.label')}
              fullWidth
              defaultValue={model.email}
              type="email"
              onChange={(e) => onChange({ ...model, email: e.target.value })}
              disabled
            />
          </S.Field>
        </S.FormGroup>
      </S.Form>
    </S.Wrapper>
  );
};

export default FlightBookPassengersForm;
